import React from 'react'

import {
    InboxOutlined,

} from "@ant-design/icons";

import { Collapse } from "antd";
import RelatedArticle from '../../Images/relatedArticle.svg'
import { returnMockDataSource } from "../../Services/mockData";

const text = `
Based on the given db_response, I found a relevant answer for your query 'how to update my mobile number in tataplay'. If you have any further questions or concerns, please feel free to ask.
`;

const items = [
    {
        key: "1",
        label: "This is panel header 1",
        children: <p>{text}</p>,
    },
    {
        key: "2",
        label: "This is panel header 2",
        children: <p>{text}</p>,
    },
    {
        key: "3",
        label: "This is panel header 3",
        children: <p>{text}</p>,
    },
];

function RelatedArticles() {
    return (

        <div className="oneConversation-right">
            <div style={{color :'white'}} className="oneConversation-right-articles">

                <>
                    <InboxOutlined /> Related Articles
                    <Collapse
                        // defaultActiveKey={["1"]}
                        ghost
                        // items={items}
                    />
                </>

            </div>
        </div>

    )
}



// const RelatedArticles = (props) => {

//     const {  showMaximumChat , clearMessages ,setShowMsgs} = props
//     return (
//         <>
//             <div style={{width : '50%' ,marginTop :'3%' }}>
//                 <div style={{ marginLeft: '5%', alignItems: 'center' ,display :'flex'}}>
//                     <img style={{ width: '24px', height: '28px' }} src={RelatedArticle} alt="source"></img>
//                     <span style={{ fontSize: '18px', fontWeight: '400', lineHeight: '28px', marginLeft: '1%' }}>Related Articles</span>
//                 </div>
//                 <div
//                     style={{
//                         width: "79%",
//                         overflow: "scroll",           
//                         marginLeft: "10px",
//                     }}
//                 >
//                     {returnMockDataSource("sources")?.response?.llm_response?.llm_response?.map(
//                         (source, index) => (
//                             <div className="article-box">
//                                 <div
//                                     style={{
//                                         display: "flex",
//                                         alignItems: "flex-start",
//                                         width: "max-content",
//                                         marginTop: "10px",
//                                     }}
//                                 >
//                                     <img
//                                         height={"30px"}
//                                         width={"30px"}
//                                         className="logo-img"
//                                         alt="src"
//                                         //   style={{ borderRadius: "50%" }}
//                                         src={source.icon}
//                                     ></img>
//                                 </div>
//                                 <div
//                                     style={{
//                                         width: "max-content",
//                                         fontSize: "10px",
//                                         marginLeft: "4x",
//                                         maxWidth: "12rem",
//                                     }}
//                                 >
//                                     <span style={{ marginBottom: '-2rem', marginLeft: '10px', color: '#13343B' }}>{source.title}</span>
//                                     <p style={{ margin: "5px 0px 10px 10px", color: '#64645F' }}>{source.description}</p>
//                                 </div>
//                             </div>
//                         )
//                     )}
//                 </div>
//                 {showMaximumChat && (
//                     <div
//                         style={{
//                             display: "flex",
//                             height: "2rem",
//                             justifyContent: "flex-end",
//                             marginBottom: "10px",
//                             width: showMaximumChat ? "87%" : "92%",
//                             cursor: "pointer",
//                         }}
//                     >
//                     </div>
//                 )}

//                 {/* <hr className="lineanimated"></hr> */}
//             </div>
//         </>

//     )
// }

export default RelatedArticles
